import { useEffect, useRef, useState } from 'react';
import MembershipTypeEdit from './MembershipTypeEdit';
import MembershipApplicablesShops from './MembershipApplicablesShops';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal';
import { columnsheadId } from '../../universal/columnshead';
import { Button, Space } from 'antd';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import CustomSelect from '../../../utilsTsx/components/hooks/CustomSelect';

const WebComponent = (props: any) => {
    const apiId = 'membershipType';
    const ref = useRef<any>(undefined);
    const [membershipTypeId, setMembershipTypeId] = useState<any>();
    const [modalVisibleMembershipApplicablesShops, setModalVisibleMembershipApplicablesShops] = useState<any>();
    const [membershipPointsPlansData, setMembershipPointsPlansData] = useState<any>();
    const [fetchData, setFetchData] = useState<any>();
    const [sendPageData, setSendPageData] = useState<any>();

    useEffect(() => {
        let urlService;
        if (ref.current) {
            urlService = ref.current.defaultService;
            setFetchData(() => ref.current.fetchData);
            setSendPageData(ref.current.sendPageData);
        }
        fetchApi.GET(urlService,
            {
                query: {
                    apiId: 'membershipPointsPlans',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setMembershipPointsPlansData([{ id: 'ALLITEM', planName: '所有积分方案' }, ...res.data]);
                }
            })
    }, []);

    //表头
    const columnsHead = [
        {
            title: '名称',
            dataIndex: 'typeName',
        },
        {
            title: '适合店铺',
            dataIndex: 'id',
            render: (val: any) => (
                <>
                    <Space>
                        <Button type='primary' onClick={() => {
                            setMembershipTypeId({
                                membershipTypeId: val
                            })
                            setModalVisibleMembershipApplicablesShops(true);
                        }}>{'适合店铺'}</Button>
                    </Space>
                </>
            )
        },
        {
            title: '默认',
            dataIndex: 'isDefault',
            render: (val: boolean) => val === true ? '是' : '否'
        },
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WebUniversalProps = {
        ...props,
        titleName: '会员类别',
        apiId,
        columns,
        serviceId: 'business',
        editOptions: {
            Editor: MembershipTypeEdit
        }
    };

    return (
        <>
            <Space>
                <CustomSelect
                    apiId={apiId}
                    sendKeyId='membershipPointsPlansId'
                    getListData={membershipPointsPlansData}
                    sendPageData={sendPageData}
                    setSendPageData={setSendPageData}
                    fetchData={fetchData}
                    itemName="planName"
                />
            </Space>
            <> </>
            <WebUniversal {...extendProps} ref={ref} />
            {modalVisibleMembershipApplicablesShops ?
                (<MembershipApplicablesShops
                    closeModal={() => setModalVisibleMembershipApplicablesShops(false)}
                    data={membershipTypeId} />)
                : null}
        </>
    )
}

export default WebComponent;
